import React from 'react';

import cs from 'classnames';

import Icon from '../../Icon/Icon';
import Skeleton from '../../Skeleton/Skeleton';

const BreadcrumbSkeleton = ({
  stepsLength,
  className,
  splitType = 'arrow',
  hasBackButton = false
}) => {
  const skeletonCount = stepsLength < 2 ? 3 : stepsLength;

  return (
    <div
      className={cs('flex w-full items-center gap-2 overflow-x-auto overflow-y-hidden', className)}>
      {hasBackButton && <div className="h-4 w-4 animate-pulse rounded bg-neutral-200" />}

      {Array.from({ length: skeletonCount }, (_, index) => (
        <React.Fragment key={index}>
          <Skeleton
            height="20px"
            width={`${[80, 60, 90, 70, 85][index % 5]}px`} // Cycle through realistic widths
            baseColor="#EEEEEE"
            highlight="#FAFAFA"
            className="rounded text-sm"
          />
          {index !== skeletonCount - 1 &&
            (splitType === 'arrow' ? (
              <Icon icon="chevron-right-linear" color="neutral" size="sm" />
            ) : (
              <span className="text-sm text-neutral-400">/</span>
            ))}
        </React.Fragment>
      ))}
    </div>
  );
};

export default BreadcrumbSkeleton;
